export enum BookingStatus {
  New = "New",
  Quote = "Quote",
  Reserved = "Reserved",
  ContractCreated = "ContractCreated",
  Cancelled = "Cancelled",
  NoShow = "NoShow",

  NewContract = "NewContract",
  Confirm = "Confirmed",
  ContractSigned = "ContractSigned",
  CheckedOut = "CheckedOut",
  PaymentPending = "PaymentPending",
  Completed = "Completed",
  Void = "Void",
  NoShowContract = "NoShowContract",
}

export enum ContractStatus {
  New = "New",
  Confirm = "Confirmed",
  ContractSigned = "ContractSigned",
  CheckedOut = "CheckedOut",
  PaymentPending = "PaymentPending",
  Completed = "Completed",
  Void = "Void",
  NoShow = "NoShow",
}

export enum BookingAction {
  CreateNew = "CreateNew",
  CreateQuote = "CreateQuote",
  Reserve = "Reserve",
  Cancel = "Cancel",
  CreateContract = "CreateNew",
  NoShow = "NoShow",
  // CreateNew = "CreateNew",
  SignContract = "SignContract",
  Void = "Void",
  Checkout = "Checkout",
  CheckIn = "CheckIn",
  Confirm = "Confirm",
  // NoShow = "NoShow",
  CompleteContract = "CompleteContract",
  NA = "NA",
}

export enum ContractAction {
  CreateNew = "CreateNew",
  SignContract = "SignContract",
  Void = "Void",
  Checkout = "Checkout",
  CheckIn = "CheckIn",
  Confirm = "Confirm",
  NoShow = "NoShow",
  CompleteContract = "CompleteContract",
  NA = "NA",
}

export enum RentContractStatus {
  New = "New",
  Active = "Active",
  Completed = "Completed",
  Terminated = "Terminated",
  Void = "Void",
}

export enum RentContractType {
  Retail = "Retail",
  OneWay = "OneWay",
  Insurance = "Insurance",
  Corporate = "Corporate",
}
